import Vue from 'vue'
import Vuex from 'vuex'
import Persisted from 'vuex-persistedstate'

import users from './modules/Users'
import loader from './modules/Loader'
import conseillers from './modules/Conseillers'
import cabinets from './modules/Cabinets'
import clients from './modules/Clients'
// import contracts from './modules/Contracts'
// import supports from './modules/Supports'
import notifications from './modules/Notifications'
import { STORAGE_KEY } from './state'

Vue.use(Vuex)

const store = new Vuex.Store({
	strict: true,
	plugins: [Persisted({
		key: STORAGE_KEY
	})],
	modules: {
		users,
    loader,
		clients,
		cabinets,
		conseillers,
		// contracts,
		// supports,
		notifications
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js